import { z } from 'zod';

export const onboardingKeySchema = z.object({
  environmentKey: z
    .string()
    .trim()
    .min(1, 'Paste the environment key from your Claude organization.'),
});

export type OnboardingKeyValues = z.infer<typeof onboardingKeySchema>;

export const ONBOARDING_KEY_DEFAULTS: OnboardingKeyValues = { environmentKey: '' };
